export default "__VITE_ASSET__DtWUtRZO__"